<template>
  <div class="notification-item">
    <img :src="url">
    <div class="content">
      <p class="title">{{ detail.title || '-' }}</p>
      <div class="desc">
        <el-tooltip class="item" effect="dark" :content="detail.wsContent" placement="top-start">
          <span class="socket-content" :class="{'width-limit': check}">{{ detail.wsContent || '-' }}</span>
        </el-tooltip>
        <span v-if="check" class="check" @click="goCheck">{{ check }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep'
export default {
  name: 'NotificationItem',
  props: {
    detail: {
      type: Object,
      default: () => {
        return {
          msgType: 1,
          icon: 1
        }
      }
    }
  },
  data() {
    return {}
  },
  computed: {
    url() {
      let url = ''
      switch (this.detail.icon) {
        case 1:
          url = require('@/assets/notify/waiting.png')
          break
        case 2:
          url = require('@/assets/notify/status.png')
          break
        case 3:
          url = require('@/assets/notify/copy.png')
          break
        case 4:
          url = require('@/assets/notify/message.png')
          break
        default :
          url = require('@/assets/notify/status.png')
      }
      return url
    },
    check() {
      let name = ''
      switch (this.detail.icon) {
        case 1:
          name = '待你审批'
          break
        case 2:
          name = '待你查阅'
          break
        case 3:
          name = '待你查阅'
          break
        case 4:
          name = '待你查阅'
          break
        default :
          name = ''
      }
      return name
    }
  },
  methods: {
    goCheck() {
      const openTypeMap = {
        3: 2, // 待办
        2: 4, // 抄送
        1: 3 // 查看
      }
      const { msgType, operationType } = this.detail
      console.log('detail', this.detail)
      this.$emit('dealMessage', cloneDeep(this.detail), openTypeMap[msgType], operationType)
      this.$parent.close()
    }
  }
}
</script>

<style lang="scss">
  .el-notification.bpm-notify {
    .el-notification__group {
      margin-left: 0px;
    }
    padding: 20px 26px 20px 16px;
    width: 400px;
    box-shadow: 7px 10px 40px 0px rgba(0,0,0,0.1);
    border-radius: 4px;
  }
</style>
<style lang="scss" scoped>
  .notification-item {
    display: flex;
    align-items: center;
    img {
      width: 56px;
      height: 56px;
    }
    .content {
      padding-left: 16px;
      .title {
        font-size: 16px;
        font-weight: 500;
        line-height: 24px;
        color: #1D2129;
        padding-bottom: 4px;
        max-width: 266px;
        white-space: nowrap;/*内容超宽后禁止换行显示*/
        overflow: hidden;/*超出部分隐藏*/
        text-overflow:ellipsis;/*文字超出部分以省略号显示*/
      }
      .desc {
        font-size: 14px;
        font-weight: 400;
        color: #666666;
        line-height: 22px;
        display: flex;
        align-items: center;
        max-width: 300px;
        .socket-content {
          display: inline-block;
          line-height: 22px;
          white-space: nowrap;/*内容超宽后禁止换行显示*/
          overflow: hidden;/*超出部分隐藏*/
          text-overflow:ellipsis;/*文字超出部分以省略号显示*/
          &.width-limit {
            max-width: 200px;
          }
        }
        .check {
          display: inline-block;
          cursor: pointer;
          color: #2C51EF;
          line-height: 22px;
          padding-left: 6px;
        }
      }
    }
  }
</style>
